import { ReactElement } from "react"
import { DeepReadonly } from "ts-essentials"
import OPTooltip from "components/material/tooltip"

export default function DynamicEllipsisWithTooltip({ children, title }: DeepReadonly<DynamicEllipsisWithTooltipProps>) {
  return <span className="text-overflow-dynamic-container">
    <span className="text-overflow-dynamic-ellipsis">
      <OPTooltip placement="bottom-start" classes={{ popper: "large-tooltip" }} title={title || children}><span>{children}</span></OPTooltip>
    </span>
  </span>
}

interface DynamicEllipsisWithTooltipProps {
  title: string | string[]
  children: ReactElement
}
